// extracted by mini-css-extract-plugin
export var Container = "benefices-module--Container--1zinp";
export var LineBreak = "benefices-module--LineBreak--2B-m4";
export var Title1 = "benefices-module--Title1--h3FKo";
export var HtmlDiv = "benefices-module--HtmlDiv--3oP0e";
export var GreyRow = "benefices-module--GreyRow--3UX2H";
export var GreyCol = "benefices-module--GreyCol--1NsWA";